// DoctorsTab.tsx
import React from "react";
import { DoctorEarnings, ColorTheme } from "../types/revenue.types";
import { DoctorEarningsCard } from "../cards/DoctorEarningsCard";
import RevenueService from "../../../services/revenueService";

interface DoctorsTabProps {
  doctorEarnings: DoctorEarnings[];
  colorTheme: ColorTheme;
}

export const DoctorsTab: React.FC<DoctorsTabProps> = ({
  doctorEarnings,
  colorTheme,
}) => {
  const totalEarnings = doctorEarnings.reduce(
    (sum, d) => sum + d.total_earned,
    0,
  );
  const totalPending = doctorEarnings.reduce(
    (sum, d) => sum + d.pending_amount,
    0,
  );

  return (
    <div>
      {/* Summary Header */}
      <div
        style={{
          background: "white",
          padding: "24px",
          borderRadius: "12px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: colorTheme.gray900,
                marginBottom: "4px",
              }}
            >
              👨‍⚕️ Worker Earnings
            </h2>
            <p style={{ fontSize: "14px", color: colorTheme.gray600 }}>
              {doctorEarnings.length} workers
            </p>
          </div>
          <div style={{ textAlign: "right" }}>
            <div
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: colorTheme.success,
              }}
            >
              {RevenueService.formatCurrency(totalEarnings)}
            </div>
            {totalPending > 0 && (
              <div
                style={{
                  fontSize: "12px",
                  color: colorTheme.warning,
                  fontWeight: "500",
                }}
              >
                Pending: {RevenueService.formatCurrency(totalPending)}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Doctor Cards */}
      {doctorEarnings.map((doctor) => (
        <DoctorEarningsCard
          key={doctor.doctor_id}
          doctor={doctor}
          colorTheme={colorTheme}
        />
      ))}

      {doctorEarnings.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: colorTheme.gray500,
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>👨‍⚕️</div>
          <p>No worker earnings found for the selected period.</p>
        </div>
      )}
    </div>
  );
};
